import { downloadFileBase64 } from '@/services/reusable';
import { isUndefinedOrEmptyStringOrNull } from './reuseble';
function isPlainObject(data) {
    return data && typeof data === 'object' && !Array.isArray(data);
}
export function jsonToFormData(values, mode = 'create', notNullableValues = []) {
    const body = mode == 'create' ? new FormData() : new URLSearchParams();
    Object.entries(values).forEach(([key, value]) => {
        if (key != 'image' && key != 'img') {
            if (Array.isArray(value)) {
                value.forEach((el, index) => {
                    if (typeof el == 'string' || typeof el == 'number') {
                        body.append(`${key}[${index}]`, el);
                    } else {
                        Object.entries(el).forEach(([subKey, subValue]) => {
                            body.append(`${key}[${index}][${subKey}]`, subValue);
                        });
                    }
                });
            } else {
                if (notNullableValues.includes(key)) {
                    if (!isUndefinedOrEmptyStringOrNull(value)) {
                        body.append(key, value);
                    }
                } else {
                    if (!isPlainObject(value)) {
                        body.append(key, value);
                    } else if (value instanceof File) {
                        body.append(key, value);
                    } else {
                        Object.entries(value).forEach(([subKey, subValue]) => {
                            body.append(`${key}[${subKey}]`, subValue);
                        });
                    }
                }
            }
        }
    });
    return body;
}

export function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onloadend = () => {
            const base64String = reader.result;
            resolve(base64String);
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsDataURL(blob);
    });
}

export async function fileUrlToBase64(path = null) {
    if (!path) {
        return;
    }

    return new Promise((resolve, reject) => {
        downloadFileBase64({ url: path })
            .then((base64) => {
                resolve(base64);
            })
            .catch((e) => reject(e));
    });
}
